import React from 'react';
import AppRoutes from '@router/index';
import Notification from 'react-notify-toast';
import FullPageSpinner from '@hoc/partials/FullPageSpinner';
import AuthProvider from '@core/AuthProvider';
import LanguageSelector from "@core/dropdowns/LanguageSelector";

const App = () => {
  return (
    <>
      <Notification options={{zIndex: 2000, top: 10}}/>
      <AuthProvider>
        <div className='mx-auto relative' style={{ maxWidth: 600 }}>
          <div className='bg-transparent text-white p-4 fixed w-full' style={{ maxWidth: 100, zIndex: 1999, right: 0 }}>
            <div className='mx-auto flex justify-end'>
              <LanguageSelector />
            </div>
          </div>
          <AppRoutes />
        </div>
      </AuthProvider>
      <FullPageSpinner/>
    </>
  );
};

export default App;
